// extracted by mini-css-extract-plugin
export default {"Grid":"Grid_Grid__qpamJ","GridMobile":"Grid_GridMobile__mryPY"};